"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GlobalNav_1 = require("./GlobalNav");
exports.default = GlobalNav_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/global/GlobalNav/index.js
// module id = 1391
// module chunks = 8